import { RefObject } from 'react'

export const onScrollStop = (callback: () => void, ref: RefObject<HTMLElement>) => (): void => {
    let timeout: NodeJS.Timeout

    ref?.current?.addEventListener(
        'scroll',
        () => {
            clearTimeout(timeout)
            timeout = setTimeout(() => {
                callback()
            }, 150)
        },
        false
    )
}

type ScrollStopCallback = {
    ref: RefObject<HTMLElement>
    setActive: (active: number) => void
    itemsCount: number
}

export const scrollStopCallback =
    ({ ref, setActive, itemsCount }: ScrollStopCallback) =>
    (): void => {
        const wrapper = ref.current
        const scrollWidth = wrapper?.scrollWidth ?? 0
        const scrollLeft = wrapper?.scrollLeft ?? 0
        const itemSize = scrollWidth / itemsCount

        setActive(itemSize ? Math.floor(scrollLeft / itemSize) : 0)
    }

type OnUpdateActive = {
    ref: RefObject<HTMLElement>
    itemsCount: number
    active: number
}

export const onUpdateActive =
    ({ ref, active, itemsCount }: OnUpdateActive) =>
    (): void => {
        if (!itemsCount) {
            return
        }

        const wrapper = ref.current
        const itemSize = (wrapper?.scrollWidth ?? 0) / itemsCount

        ref.current?.scroll?.(itemSize * active, 0)
    }

type OnDotClick = {
    setActive: (active: number) => void
    active: number
}
export const onDotClick =
    ({ setActive, active }: OnDotClick) =>
    (): void =>
        setActive(active)
